export const FilterCategories = [
  {
    id: 3,
    title: "lifestyle",
    sub_categories: [
      {
        id: 1,
        title: "fashion and apparel",
      },
      {
        id: 3,
        title: "childcare",
      },
      {
        id: 4,
        title: "beauty and cosmetics",
      },
      {
        id: 9,
        title: "jewelry and luxury products",
      },
      {
        id: 16,
        title: "other lifestyle",
      },
      {
        id: 17,
        title: "lifestyle - other",
      },
      {
        id: 28,
        title: "weddings",
      },
      {
        id: 32,
        title: "gifts and flowers",
      },
      {
        id: 129,
        title: "tobacco",
      },
    ],
  },
  {
    id: 43,
    title: "sports",
    sub_categories: [
      {
        id: 7,
        title: "other sports",
      },
      {
        id: 8,
        title: "sports - other",
      },
      {
        id: 33,
        title: "hunting and shooting",
      },
      {
        id: 39,
        title: "martial arts",
      },
      {
        id: 40,
        title: "water sports",
      },
      {
        id: 43,
        title: "cycling and biking",
      },
      {
        id: 57,
        title: "golf",
      },
      {
        id: 60,
        title: "fishing",
      },
      {
        id: 68,
        title: "fantasy sports",
      },
      {
        id: 74,
        title: "winter sports",
      },
      {
        id: 77,
        title: "running",
      },
      {
        id: 78,
        title: "basketball",
      },
      {
        id: 99,
        title: "boxing",
      },
      {
        id: 116,
        title: "baseball",
      },
      {
        id: 122,
        title: "soccer",
      },
      {
        id: 131,
        title: "tennis",
      },
      {
        id: 140,
        title: "american football",
      },
      {
        id: 143,
        title: "climbing",
      },
    ],
  },
  {
    id: 11,
    title: "product/service",
    sub_categories: [],
  },
  {
    id: 22,
    title: "clothing (brand)",
    sub_categories: [],
  },
  {
    id: 52,
    title: "food and drink",
    sub_categories: [
      {
        id: 11,
        title: "other food and drink",
      },
      {
        id: 12,
        title: "food and drink - other",
      },
      {
        id: 15,
        title: "groceries",
      },
      {
        id: 26,
        title: "restaurants and delivery",
      },
      {
        id: 36,
        title: "beverages",
      },
      {
        id: 105,
        title: "cooking and recipes",
      },
      {
        id: 121,
        title: "vegetarian and vegan",
      },
    ],
  },
  {
    id: 69,
    title: "home and garden",
    sub_categories: [
      {
        id: 18,
        title: "other home and garden",
      },
      {
        id: 19,
        title: "home and garden - other",
      },
      {
        id: 27,
        title: "gardening",
      },
      {
        id: 50,
        title: "furniture",
      },
      {
        id: 62,
        title: "home improvement and maintenance",
      },
      {
        id: 130,
        title: "interior design",
      },
    ],
  },
  {
    id: 20,
    title: "health/beauty",
    sub_categories: [],
  },
  {
    id: 56,
    title: "health",
    sub_categories: [
      {
        id: 13,
        title: "other health",
      },
      {
        id: 14,
        title: "health - other",
      },
      {
        id: 22,
        title: "nutrition diets and fitness",
      },
      {
        id: 48,
        title: "womens health",
      },
      {
        id: 53,
        title: "health conditions and concerns",
      },
      {
        id: 59,
        title: "alternative and natural medicine",
      },
      {
        id: 85,
        title: "dentist and dental services",
      },
      {
        id: 98,
        title: "mental health",
      },
      {
        id: 106,
        title: "childrens health",
      },
      {
        id: 109,
        title: "pharmacy",
      },
      {
        id: 145,
        title: "biotechnology and pharmaceuticals",
      },
      {
        id: 146,
        title: "developmental and physical disabilities",
      },
    ],
  },
  {
    id: 31,
    title: "shopping & retail",
    sub_categories: [],
  },
  {
    id: 70,
    title: "ecommerce & shopping",
    sub_categories: [
      {
        id: 20,
        title: "other ecommerce and shopping",
      },
      {
        id: 21,
        title: "ecommerce and shopping - other",
      },
      {
        id: 41,
        title: "marketplace",
      },
      {
        id: 110,
        title: "coupons and rebates",
      },
      {
        id: 120,
        title: "auctions",
      },
      {
        id: 124,
        title: "classifieds",
      },
    ],
  },
  {
    id: 101,
    title: "computers electronics and technology",
    sub_categories: [
      {
        id: 23,
        title: "consumer electronics",
      },
      {
        id: 29,
        title: "graphics multimedia and web design",
      },
      {
        id: 52,
        title: "telecommunications",
      },
      {
        id: 58,
        title: "programming and developer software",
      },
      {
        id: 61,
        title: "email",
      },
      {
        id: 63,
        title: "computer hardware",
      },
      {
        id: 80,
        title: "other computers electronics and technology",
      },
      {
        id: 81,
        title: "computers electronics and technology - other(in united states",
      },
      {
        id: 86,
        title: "computers electronics and technology - other",
      },
      {
        id: 92,
        title: "social media networks",
      },
      {
        id: 128,
        title: "other computers electronics and technology(in bosnia and herz",
      },
      {
        id: 150,
        title: "advertising networks",
      },
      {
        id: 154,
        title: "web hosting and domain names",
      },
    ],
  },
  {
    id: 41,
    title: "pets and animals",
    sub_categories: [
      {
        id: 6,
        title: "pet food and supplies",
      },
      {
        id: 30,
        title: "other pets and animals",
      },
      {
        id: 31,
        title: "pets and animals - other",
      },
      {
        id: 54,
        title: "animals",
      },
      {
        id: 75,
        title: "pets",
      },
      {
        id: 103,
        title: "fish and aquaria",
      },
      {
        id: 108,
        title: "horses",
      },
      {
        id: 125,
        title: "birds",
      },
    ],
  },
  {
    id: 118,
    title: "business and consumer services",
    sub_categories: [
      {
        id: 24,
        title: "digital marketing",
      },
      {
        id: 25,
        title: "marketing and advertising",
      },
      {
        id: 38,
        title: "business services",
      },
      {
        id: 89,
        title: "other business and consumer services",
      },
      {
        id: 90,
        title: "business and consumer services - other",
      },
      {
        id: 91,
        title: "textiles",
      },
      {
        id: 102,
        title: "printing & self publishing",
      },
      {
        id: 112,
        title: "real estate",
      },
      {
        id: 114,
        title: "shipping and logistics",
      },
    ],
  },
  {
    id: 9,
    title: "e-commerce website",
    sub_categories: [],
  },
  {
    id: 58,
    title: "retail company",
    sub_categories: [],
  },
  {
    id: 113,
    title: "shopping & fashion",
    sub_categories: [],
  },
  {
    id: 156,
    title: "home decor",
    sub_categories: [],
  },
  {
    id: 6,
    title: "vehicles",
    sub_categories: [
      {
        id: 2,
        title: "motorcycles",
      },
      {
        id: 10,
        title: "automotive industry",
      },
      {
        id: 37,
        title: "motorsports",
      },
      {
        id: 45,
        title: "other vehicles",
      },
      {
        id: 46,
        title: "vehicles - other",
      },
      {
        id: 72,
        title: "makes and models",
      },
      {
        id: 73,
        title: "aviation",
      },
      {
        id: 117,
        title: "boats",
      },
    ],
  },
  {
    id: 2,
    title: "jewelry/watches",
    sub_categories: [],
  },
  {
    id: 5,
    title: "brand",
    sub_categories: [],
  },
  {
    id: 262,
    title: "arts & entertainment",
    sub_categories: [
      {
        id: 44,
        title: "streaming & online tv",
      },
      {
        id: 69,
        title: "other arts and entertainment",
      },
      {
        id: 70,
        title: "arts and entertainment - other",
      },
      {
        id: 83,
        title: "music",
      },
      {
        id: 88,
        title: "visual arts and design",
      },
      {
        id: 101,
        title: "humor",
      },
      {
        id: 139,
        title: "animation and comics",
      },
      {
        id: 144,
        title: "books and literature",
      },
    ],
  },
  {
    id: 66,
    title: "beauty, cosmetic & personal care",
    sub_categories: [],
  },
  {
    id: 21,
    title: "games",
    sub_categories: [
      {
        id: 5,
        title: "video games consoles and accessories",
      },
      {
        id: 49,
        title: "games - other",
      },
      {
        id: 51,
        title: "other games",
      },
      {
        id: 79,
        title: "board and card games",
      },
      {
        id: 87,
        title: "puzzles and brainteasers",
      },
      {
        id: 111,
        title: "roleplaying games",
      },
    ],
  },
  {
    id: 8,
    title: "interest",
    sub_categories: [],
  },
  {
    id: 7,
    title: "baby goods/kids goods",
    sub_categories: [],
  },
  {
    id: 273,
    title: "outdoor & sporting goods company",
    sub_categories: [],
  },
  {
    id: 254,
    title: "hobbies and leisure",
    sub_categories: [
      {
        id: 42,
        title: "photography",
      },
      {
        id: 104,
        title: "crafts",
      },
      {
        id: 107,
        title: "antiques and collectibles",
      },
      {
        id: 118,
        title: "camping scouting and outdoors",
      },
      {
        id: 123,
        title: "ancestry and genealogy",
      },
      {
        id: 132,
        title: "models",
      },
    ],
  },
  {
    id: 61,
    title: "local business",
    sub_categories: [],
  },
  {
    id: 39,
    title: "pet supplies",
    sub_categories: [],
  },
  {
    id: 32,
    title: "clothing store",
    sub_categories: [],
  },
  {
    id: 174,
    title: "food & beverage",
    sub_categories: [],
  },
  {
    id: 157,
    title: "electronics",
    sub_categories: [],
  },
  {
    id: 27,
    title: "beauty & well-being",
    sub_categories: [],
  },
  {
    id: 14,
    title: "women's clothing store",
    sub_categories: [],
  },
  {
    id: 28,
    title: "vitamins/supplements",
    sub_categories: [],
  },
  {
    id: 53,
    title: "health & wellness website",
    sub_categories: [],
  },
  {
    id: 110,
    title: "footwear store",
    sub_categories: [],
  },
  {
    id: 260,
    title: "kitchen/cooking",
    sub_categories: [],
  },
  {
    id: 23,
    title: "software company",
    sub_categories: [],
  },
  {
    id: 121,
    title: "website",
    sub_categories: [],
  },
  {
    id: 51,
    title: "bags/luggage",
    sub_categories: [],
  },
  {
    id: 123,
    title: "home & garden",
    sub_categories: [],
  },
  {
    id: 85,
    title: "design & fashion",
    sub_categories: [],
  },
  {
    id: 302,
    title: "sports & recreation",
    sub_categories: [],
  },
  {
    id: 186,
    title: "gift shop",
    sub_categories: [],
  },
  {
    id: 102,
    title: "food & beverage company",
    sub_categories: [],
  },
  {
    id: 475,
    title: "community and society",
    sub_categories: [
      {
        id: 65,
        title: "faith and beliefs",
      },
      {
        id: 84,
        title: "lgbtq",
      },
      {
        id: 94,
        title: "other community and society",
      },
      {
        id: 95,
        title: "community and society - other",
      },
      {
        id: 127,
        title: "holidays and seasonal events",
      },
      {
        id: 135,
        title: "philanthropy",
      },
      {
        id: 149,
        title: "dating and relationships",
      },
    ],
  },
  {
    id: 481,
    title: "artist",
    sub_categories: [],
  },
  {
    id: 477,
    title: "games/toys",
    sub_categories: [],
  },
  {
    id: 75,
    title: "news & media publishers(in united states)",
    sub_categories: [],
  },
  {
    id: 227,
    title: "apparel & clothing",
    sub_categories: [],
  },
  {
    id: 177,
    title: "arts & crafts store",
    sub_categories: [],
  },
  {
    id: 42,
    title: "sporting goods store",
    sub_categories: [],
  },
  {
    id: 353,
    title: "finance",
    sub_categories: [
      {
        id: 55,
        title: "other finance",
      },
      {
        id: 56,
        title: "finance - other",
      },
      {
        id: 64,
        title: "financial planning and management",
      },
      {
        id: 66,
        title: "banking credit and lending",
      },
      {
        id: 93,
        title: "accounting and auditing",
      },
      {
        id: 119,
        title: "investing",
      },
    ],
  },
  {
    id: 137,
    title: "accessories",
    sub_categories: [],
  },
  {
    id: 194,
    title: "electronics & technology",
    sub_categories: [],
  },
  {
    id: 76,
    title: "cosmetics store",
    sub_categories: [],
  },
  {
    id: 19,
    title: "furniture store",
    sub_categories: [],
  },
  {
    id: 45,
    title: "company",
    sub_categories: [],
  },
  {
    id: 1,
    title: "community",
    sub_categories: [],
  },
  {
    id: 74,
    title: "news & media publishers(in usa)",
    sub_categories: [],
  },
  {
    id: 143,
    title: "furniture",
    sub_categories: [],
  },
  {
    id: 112,
    title: "media/news company",
    sub_categories: [],
  },
  {
    id: 298,
    title: "sports",
    sub_categories: [],
  },
  {
    id: 205,
    title: "pet store",
    sub_categories: [],
  },
  {
    id: 513,
    title: "gambling",
    sub_categories: [
      {
        id: 76,
        title: "casinos",
      },
      {
        id: 82,
        title: "lottery",
      },
      {
        id: 96,
        title: "other gambling",
      },
      {
        id: 97,
        title: "gambling - other",
      },
      {
        id: 133,
        title: "sports betting",
      },
    ],
  },
  {
    id: 122,
    title: "jewelry & watches store",
    sub_categories: [],
  },
  {
    id: 188,
    title: "tools/equipment",
    sub_categories: [],
  },
  {
    id: 297,
    title: "events & entertainment",
    sub_categories: [],
  },
  {
    id: 673,
    title: "bicycle shop",
    sub_categories: [],
  },
  {
    id: 126,
    title: "sunglasses & eyewear store",
    sub_categories: [],
  },
  {
    id: 151,
    title: "food, beverages & tobacco",
    sub_categories: [],
  },
  {
    id: 99,
    title: "health & medical",
    sub_categories: [],
  },
  {
    id: 270,
    title: "vehicles & transportation",
    sub_categories: [],
  },
  {
    id: 18,
    title: "fashion and apparel",
    sub_categories: [],
  },
  {
    id: 310,
    title: "men's clothing store",
    sub_categories: [],
  },
  {
    id: 100,
    title: "camera/photo",
    sub_categories: [],
  },
  {
    id: 108,
    title: "household supplies",
    sub_categories: [],
  },
  {
    id: 65,
    title: "medical & health",
    sub_categories: [],
  },
  {
    id: 508,
    title: "outdoor equipment store",
    sub_categories: [],
  },
  {
    id: 158,
    title: "boutique store",
    sub_categories: [],
  },
  {
    id: 679,
    title: "musical instrument store",
    sub_categories: [],
  },
  {
    id: 140,
    title: "internet company",
    sub_categories: [],
  },
  {
    id: 16,
    title: "nonprofit organization",
    sub_categories: [],
  },
  {
    id: 492,
    title: "heavy industry and engineering",
    sub_categories: [
      {
        id: 71,
        title: "construction and maintenance",
      },
      {
        id: 137,
        title: "chemical industry",
      },
      {
        id: 142,
        title: "energy industry",
      },
      {
        id: 147,
        title: "other heavy industry and engineering",
      },
      {
        id: 151,
        title: "metals and mining",
      },
      {
        id: 152,
        title: "agriculture",
      },
    ],
  },
  {
    id: 144,
    title: "electronics store",
    sub_categories: [],
  },
  {
    id: 94,
    title: "skin care service",
    sub_categories: [],
  },
  {
    id: 170,
    title: "baby & children's clothing store",
    sub_categories: [],
  },
  {
    id: 253,
    title: "beauty product supplier",
    sub_categories: [],
  },
  {
    id: 111,
    title: "news & media website",
    sub_categories: [],
  },
  {
    id: 132,
    title: "coffee shop",
    sub_categories: [],
  },
  {
    id: 172,
    title: "home improvement",
    sub_categories: [],
  },
  {
    id: 147,
    title: "patio/garden",
    sub_categories: [],
  },
  {
    id: 181,
    title: "wine/spirits",
    sub_categories: [],
  },
  {
    id: 421,
    title: "toy store",
    sub_categories: [],
  },
  {
    id: 183,
    title: "business service",
    sub_categories: [],
  },
  {
    id: 198,
    title: "health and beauty shop",
    sub_categories: [],
  },
  {
    id: 84,
    title: "beauty and cosmetics",
    sub_categories: [],
  },
  {
    id: 219,
    title: "automotive parts store",
    sub_categories: [],
  },
  {
    id: 639,
    title: "science and education",
    sub_categories: [
      {
        id: 100,
        title: "education",
      },
      {
        id: 126,
        title: "environmental science",
      },
      {
        id: 134,
        title: "biology",
      },
      {
        id: 141,
        title: "libraries and museums",
      },
      {
        id: 153,
        title: "history",
      },
    ],
  },
  {
    id: 79,
    title: "software",
    sub_categories: [],
  },
  {
    id: 201,
    title: "fashion accessories store",
    sub_categories: [],
  },
  {
    id: 54,
    title: "activewear store",
    sub_categories: [],
  },
  {
    id: 106,
    title: "education",
    sub_categories: [],
  },
  {
    id: 485,
    title: "sportswear store",
    sub_categories: [],
  },
  {
    id: 135,
    title: "home & garden website",
    sub_categories: [],
  },
  {
    id: 412,
    title: "decoration and interior design store",
    sub_categories: [],
  },
  {
    id: 402,
    title: "clothing company",
    sub_categories: [],
  },
  {
    id: 47,
    title: "jewelry store",
    sub_categories: [],
  },
  {
    id: 90,
    title: "adult(in united states)",
    sub_categories: [],
  },
  {
    id: 218,
    title: "food delivery service",
    sub_categories: [],
  },
  {
    id: 304,
    title: "business services",
    sub_categories: [],
  },
  {
    id: 314,
    title: "art",
    sub_categories: [],
  },
  {
    id: 272,
    title: "arts & entertainment",
    sub_categories: [],
  },
  {
    id: 701,
    title: "fishing store",
    sub_categories: [],
  },
  {
    id: 82,
    title: "financial service",
    sub_categories: [],
  },
  {
    id: 180,
    title: "appliances",
    sub_categories: [],
  },
  {
    id: 308,
    title: "cell phone accessory store",
    sub_categories: [],
  },
  {
    id: 506,
    title: "baby store",
    sub_categories: [],
  },
  {
    id: 322,
    title: "health food store",
    sub_categories: [],
  },
  {
    id: 44,
    title: "public figure",
    sub_categories: [],
  },
  {
    id: 154,
    title: "fitness and nutrition service",
    sub_categories: [],
  },
  {
    id: 366,
    title: "hobby store",
    sub_categories: [],
  },
  {
    id: 15,
    title: "art gallery",
    sub_categories: [],
  },
  {
    id: 361,
    title: "garden center",
    sub_categories: [],
  },
  {
    id: 191,
    title: "grocery store",
    sub_categories: [],
  },
  {
    id: 97,
    title: "specialty grocery store",
    sub_categories: [],
  },
  {
    id: 500,
    title: "beauty supply store",
    sub_categories: [],
  },
  {
    id: 96,
    title: "wholesale & supply store",
    sub_categories: [],
  },
  {
    id: 60,
    title: "publisher",
    sub_categories: [],
  },
  {
    id: 541,
    title: "lighting store",
    sub_categories: [],
  },
  {
    id: 247,
    title: "lingerie & underwear store",
    sub_categories: [],
  },
  {
    id: 439,
    title: "pet service",
    sub_categories: [],
  },
  {
    id: 81,
    title: "lawyer & law firm",
    sub_categories: [],
  },
  {
    id: 409,
    title: "shopping service",
    sub_categories: [],
  },
  {
    id: 443,
    title: "home goods store",
    sub_categories: [],
  },
  {
    id: 463,
    title: "electronics company",
    sub_categories: [],
  },
  {
    id: 344,
    title: "bakery",
    sub_categories: [],
  },
  {
    id: 408,
    title: "entrepreneur",
    sub_categories: [],
  },
  {
    id: 274,
    title: "vitamin and supplements store",
    sub_categories: [],
  },
  {
    id: 319,
    title: "cars",
    sub_categories: [],
  },
  {
    id: 543,
    title: "construction & manufacturing",
    sub_categories: [],
  },
  {
    id: 556,
    title: "video game",
    sub_categories: [],
  },
  {
    id: 333,
    title: "education website",
    sub_categories: [],
  },
  {
    id: 225,
    title: "sports & fitness instruction",
    sub_categories: [],
  },
  {
    id: 293,
    title: "fashion designer",
    sub_categories: [],
  },
  {
    id: 223,
    title: "magazine",
    sub_categories: [],
  },
  {
    id: 265,
    title: "information technology company",
    sub_categories: [],
  },
  {
    id: 427,
    title: "jewelry & watches company",
    sub_categories: [],
  },
  {
    id: 288,
    title: "animals & pets",
    sub_categories: [],
  },
  {
    id: 129,
    title: "florist",
    sub_categories: [],
  },
  {
    id: 207,
    title: "mattress store",
    sub_categories: [],
  },
  {
    id: 529,
    title: "adult(in brazil)",
    sub_categories: [],
  },
  {
    id: 632,
    title: "fitness equipment store",
    sub_categories: [],
  },
  {
    id: 281,
    title: "hardware store",
    sub_categories: [],
  },
  {
    id: 346,
    title: "digital creator",
    sub_categories: [],
  },
  {
    id: 474,
    title: "department store",
    sub_categories: [],
  },
  {
    id: 206,
    title: "travel and tourism",
    sub_categories: [
      {
        id: 34,
        title: "other travel and tourism",
      },
      {
        id: 35,
        title: "travel and tourism - other",
      },
      {
        id: 113,
        title: "accommodation and hotels",
      },
      {
        id: 148,
        title: "tourist attractions",
      },
    ],
  },
  {
    id: 462,
    title: "beauty store",
    sub_categories: [],
  },
  {
    id: 98,
    title: "camera store",
    sub_categories: [],
  },
  {
    id: 578,
    title: "board game",
    sub_categories: [],
  },
  {
    id: 572,
    title: "baby clothing store",
    sub_categories: [],
  },
  {
    id: 554,
    title: "collectibles store",
    sub_categories: [],
  },
  {
    id: 17,
    title: "swimwear store",
    sub_categories: [],
  },
  {
    id: 190,
    title: "photographer",
    sub_categories: [],
  },
  {
    id: 497,
    title: "dessert shop",
    sub_categories: [],
  },
  {
    id: 638,
    title: "bookstore",
    sub_categories: [],
  },
  {
    id: 88,
    title: "college & university",
    sub_categories: [],
  },
  {
    id: 165,
    title: "medical supply store",
    sub_categories: [],
  },
  {
    id: 377,
    title: "hobbies & crafts",
    sub_categories: [],
  },
  {
    id: 358,
    title: "pharmacy",
    sub_categories: [],
  },
  {
    id: 250,
    title: "restaurants & bars",
    sub_categories: [],
  },
];
